/**
 * API Module Exports
 * Central export point for API endpoint management functionality
 */

// === ENDPOINT UTILITIES ===
export {
  getApiEndpointConfig,
  isApiEndpointConfigured,
  getApiEndpoint,
  getApiGateway,
  getIotApiGateway,
  getEventWebSocketUrl,
  getEndpointErrorMessage,
  validateApiEndpoints
} from './endpointUtils';

// === STORE ===
export { useApiEndpointStore } from '../store/apiEndpointStore';

// === TYPES ===
export type { ApiEndpointConfig } from './endpointUtils';

// === VERSION INFO ===
export const API_MODULE_VERSION = '1.0.0';
export const API_MODULE_NAME = 'FleetA API Endpoint Manager';